import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import LineItems, { LineItemCount } from '../components/LineItems';
import OrderNumber from '../components/OrderNumber';
import { useBrandingData } from '../components/DataProviders';

import Card, { CardHeader } from './Card';


const useStyles = makeStyles( theme => ({
  contentLabel: {
    fontSize: '10px',
    fontWeight: '700',
    lineHeight: '12px',
    textTransform: 'uppercase',
    display: 'block',
    marginBottom: '2px'
  },
  scrollableSection: {
    overflow: 'auto',
    height: 'calc(100% - 42px)',
  },
  orderNumberSection: {
    padding: '12px 20px'
  },
  orderNumber: {
    fontSize: '14px',
    fontWeight: '300',
    lineHeight: '20px'
  },
  itemsHeader: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}));


const useLineItemStyles = makeStyles( theme => ({
  item: {
    minHeight: '78px',
    marginBottom: '12px',
    '&.item--no-image': {
      minHeight: '30px',
      '& $name, & $quantity, & $options': {
        marginLeft: '20px'
      }
    }
  },
  image: {
    float: 'left',
    marginRight: '10px',
    width: '78px',
    height: '78px',
    border: '1px solid #DFE3E8',
    borderLeft: 'none',
    display: 'flex',
    '& img': {
      alignSelf: 'center',
      margin: '0 auto'
    }
  },
  name: {
    display: 'table',
    marginLeft: '88px',
    paddingRight: '20px',
    fontSize: '12px',
    fontWeight: '700',
    lineHeight: '16px'
  },
  options: {
    display: 'table',
    marginLeft: '88px',
    paddingRight: '20px',
    fontSize: '12px',
    fontWeight: '300',
    lineHeight: '20px',
    listStyleType: 'none',
    padding: '0',
    marginTop: '0',
    marginBottom: '0',
  },
  optionLabel: {
    fontWeight: 'bold',
    textTransform: 'capitalize'
  },
  quantity: {
    display: 'table',
    marginLeft: '88px',
    fontSize: '12px',
    fontWeight: '300',
    lineHeight: '20px'
  },
  unitPrice: {
    display: 'none'
  },
  subtotal: {
    display: 'none'
  }
}));


export default function LineItemsCard({ className }) {
  const classes = useStyles();
  const lineItemClasses = useLineItemStyles();
  const { toggles: { show_shipment_details } } = useBrandingData();

  if( !show_shipment_details ) {
    return null;
  }

  return (
    <Card className={className}>
      <CardHeader className={classes.itemsHeader}>
        <div>Shipment Contents</div>
        <div>
          <LineItemCount />
        </div>
      </CardHeader>
      <div className={classes.scrollableSection}>
        <div className={classes.orderNumberSection}>
          <label className={classes.contentLabel}>Order Number:</label>
          <OrderNumber className={classes.orderNumber} />
        </div>
        <LineItems classes={lineItemClasses} formatQuantity={ q => <>Qty {q}</> } />
      </div>
    </Card>
  );
}